export function GenerateAuthenticationCode(){
    const r1 = Math.floor((Math.random() * 999)+ 1).toString();
    const r2 = Math.floor((Math.random() * 999) + 1).toString();
    const time=  Math.floor((Math.random() * 99) + 1);
    
    const sumtime=(time+Math.floor(Math.random() * 999) + 100).toString();
    return(`${r1}${sumtime}${r2}`);
}
export function DecodeAuthenticationCode(parameter1,parameter2){
    const num2= parseInt(parameter1.substring(2,4));

    let part1="";
    let part2="";

    const x2=`${parameter2[0]}${parameter2[parameter2.length-1]}`;
    const x1=parameter2[parameter2.length-1]+""+parameter2[0];

    const newNum=num2+parseInt(x1);
    if(newNum.toString().length===1){
        part1="00"+newNum.toString();
    }else if(newNum.toString().length===2){
        part1="0"+newNum.toString();
    }else{
        part1=newNum.toString();
    }
    const oldNum=parseInt(parameter1.substring(parameter1.length-2))+parseInt(x1);
    if(oldNum.toString().length===1){
        part2="00"+oldNum.toString();
    }else if(oldNum.toString().length===2){
        part2="0"+oldNum.toString();
    }else{
        part2=oldNum.toString();
    }

    let c1 =(parseInt(parameter2.substring(4,7))-parseInt(x2)).toString();
    let c2 =(parseInt(parameter2.substring(7,10))-parseInt(x2)).toString();
    let c3 =(parseInt(parameter2.substring(10,13))-parseInt(x2)).toString();

    if(c1.length<=1){
        c1="0"+c1;
    }
    if(c2.length<=1){
        c2="0"+c2;
    }
    if(c3.length<=1){
        c3="0"+c3;
    }
    

    if(parameter2.substring(1,4)===part1 && parameter2.substring(13,16)===part2){

        const final=[c3,c1,c2];
        return(final.join(""));
    }else{
        console.log("1",parameter2.substring(1,4)===part1);
        console.log("2",parameter2.substring(13,16),part2);
        
        return(false);
    }
}